import React, { useState } from 'react';

import { PhoneFormStep } from 'features/authentication/SignIn/constants';

import { useExtendUx } from 'util/uxEvents';

import { SignInFormProps } from '../types';

import PhoneCodeForm from './PhoneCodeForm';
import PhoneForm from './PhoneForm';

const PhoneSignIn = ({
  onChangeSignInType,
  onError,
  onSuccess,
}: SignInFormProps) => {
  const [step, setStep] = useState(PhoneFormStep.PHONE);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneId, setPhoneId] = useState('');
  const extendUx = useExtendUx();

  extendUx({
    view: step,
  });

  return step === PhoneFormStep.PHONE ? (
    <PhoneForm
      onSetStep={setStep}
      onSetPhoneNumber={setPhoneNumber}
      onSetPhoneId={setPhoneId}
      onError={onError}
      onChangeSignInType={onChangeSignInType}
    />
  ) : (
    <PhoneCodeForm
      phoneNumber={phoneNumber}
      phoneId={phoneId}
      onSetStep={setStep}
      onSetPhoneId={setPhoneId}
      onError={onError}
      onSuccess={onSuccess}
    />
  );
};

export default PhoneSignIn;
